// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ZaupanjeInVarnostRouteImport } from './routes/zaupanje-in-varnost'
import { Route as ZasebnostRouteImport } from './routes/zasebnost'
import { Route as UporabniskaNavodilaUstvarjalciRouteImport } from './routes/uporabniska-navodila-ustvarjalci'
import { Route as UporabniskaNavodilaRouteImport } from './routes/uporabniska-navodila'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as UnikatneVsebineRouteImport } from './routes/unikatne-vsebine'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ReklamacijeRouteImport } from './routes/reklamacije'
import { Route as RegistracijaRouteImport } from './routes/registracija'
import { Route as RacunRouteImport } from './routes/racun'
import { Route as PrijavaRouteImport } from './routes/prijava'
import { Route as PredstavitevProdajalcaRouteImport } from './routes/predstavitev-prodajalca'
import { Route as PozabljenoGesloRouteImport } from './routes/pozabljeno-geslo'
import { Route as PovzetekPogojevRouteImport } from './routes/povzetek-pogojev'
import { Route as PotrdiEmailRouteImport } from './routes/potrdi-email'
import { Route as PogostaVprasanjaRouteImport } from './routes/pogosta-vprasanja'
import { Route as PogojiRouteImport } from './routes/pogoji'
import { Route as PlaciloNajemnineRouteImport } from './routes/placilo-najemnine'
import { Route as PiskotkiRouteImport } from './routes/piskotki'
import { Route as ONasRouteImport } from './routes/o-nas'
import { Route as NavdihRouteImport } from './routes/navdih'
import { Route as NastaviGesloRouteImport } from './routes/nastavi-geslo'
import { Route as NarociloUspesnoRouteImport } from './routes/narocilo-uspesno'
import { Route as NajemSpletneTrgovineRouteImport } from './routes/najem-spletne-trgovine'
import { Route as KosaricaRouteImport } from './routes/kosarica'
import { Route as IzbranoRouteImport } from './routes/izbrano'
import { Route as IdejeInNavdihRouteImport } from './routes/ideje-in-navdih'
import { Route as BlagajnaRouteImport } from './routes/blagajna'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProdajalciIndexRouteImport } from './routes/prodajalci.index'
import { Route as KategorijeIndexRouteImport } from './routes/kategorije.index'
import { Route as IzdelkiIndexRouteImport } from './routes/izdelki.index'
import { Route as ProdajalciSlugRouteImport } from './routes/prodajalci.$slug'
import { Route as NovicePotrditevRouteImport } from './routes/novice.potrditev'
import { Route as KategorijeSlugRouteImport } from './routes/kategorije.$slug'
import { Route as IzdelkiSlugRouteImport } from './routes/izdelki.$slug'
import { Route as ClanekSlugRouteImport } from './routes/clanek.$slug'
import { Route as AuthenticatedZeljeRouteImport } from './routes/_authenticated/zelje'
import { Route as AuthenticatedUstvarjalciRouteImport } from './routes/_authenticated/ustvarjalci'
import { Route as AuthenticatedTrgovinaRouteImport } from './routes/_authenticated/trgovina'
import { Route as AuthenticatedProdajaRouteImport } from './routes/_authenticated/prodaja'
import { Route as AuthenticatedPostaniProdajalecRouteImport } from './routes/_authenticated/postani-prodajalec'
import { Route as AuthenticatedNarocilaRouteImport } from './routes/_authenticated/narocila'
import { Route as AuthenticatedNajemninaRouteImport } from './routes/_authenticated/najemnina'
import { Route as AuthenticatedMojiIzdelkiRouteImport } from './routes/_authenticated/moji-izdelki'
import { Route as AuthenticatedMigracijaSlikRouteImport } from './routes/_authenticated/migracija-slik'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedPredracunNovRouteImport } from './routes/_authenticated/predracun.nov'
import { Route as AuthenticatedPredracunIdRouteImport } from './routes/_authenticated/predracun.$id'
import { Route as AuthenticatedPovprasevanjeGroupIdRouteImport } from './routes/_authenticated/povprasevanje.$groupId'
import { Route as AuthenticatedAdminOrodjaRouteImport } from './routes/_authenticated/admin.orodja'
import { Route as AuthenticatedPredracunUrediIdRouteImport } from './routes/_authenticated/predracun.uredi.$id'

const ZaupanjeInVarnostRoute = ZaupanjeInVarnostRouteImport.update({
            id: '/zaupanje-in-varnost',path: '/zaupanje-in-varnost',getParentRoute: () => rootRouteImport
          })
const ZasebnostRoute = ZasebnostRouteImport.update({
            id: '/zasebnost',path: '/zasebnost',getParentRoute: () => rootRouteImport
          })
const UporabniskaNavodilaUstvarjalciRoute = UporabniskaNavodilaUstvarjalciRouteImport.update({
            id: '/uporabniska-navodila-ustvarjalci',path: '/uporabniska-navodila-ustvarjalci',getParentRoute: () => rootRouteImport
          })
const UporabniskaNavodilaRoute = UporabniskaNavodilaRouteImport.update({
            id: '/uporabniska-navodila',path: '/uporabniska-navodila',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const UnikatneVsebineRoute = UnikatneVsebineRouteImport.update({
            id: '/unikatne-vsebine',path: '/unikatne-vsebine',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ReklamacijeRoute = ReklamacijeRouteImport.update({
            id: '/reklamacije',path: '/reklamacije',getParentRoute: () => rootRouteImport
          })
const RegistracijaRoute = RegistracijaRouteImport.update({
            id: '/registracija',path: '/registracija',getParentRoute: () => rootRouteImport
          })
const RacunRoute = RacunRouteImport.update({
            id: '/racun',path: '/racun',getParentRoute: () => rootRouteImport
          })
const PrijavaRoute = PrijavaRouteImport.update({
            id: '/prijava',path: '/prijava',getParentRoute: () => rootRouteImport
          })
const PredstavitevProdajalcaRoute = PredstavitevProdajalcaRouteImport.update({
            id: '/predstavitev-prodajalca',path: '/predstavitev-prodajalca',getParentRoute: () => rootRouteImport
          })
const PozabljenoGesloRoute = PozabljenoGesloRouteImport.update({
            id: '/pozabljeno-geslo',path: '/pozabljeno-geslo',getParentRoute: () => rootRouteImport
          })
const PovzetekPogojevRoute = PovzetekPogojevRouteImport.update({
            id: '/povzetek-pogojev',path: '/povzetek-pogojev',getParentRoute: () => rootRouteImport
          })
const PotrdiEmailRoute = PotrdiEmailRouteImport.update({
            id: '/potrdi-email',path: '/potrdi-email',getParentRoute: () => rootRouteImport
          })
const PogostaVprasanjaRoute = PogostaVprasanjaRouteImport.update({
            id: '/pogosta-vprasanja',path: '/pogosta-vprasanja',getParentRoute: () => rootRouteImport
          })
const PogojiRoute = PogojiRouteImport.update({
            id: '/pogoji',path: '/pogoji',getParentRoute: () => rootRouteImport
          })
const PlaciloNajemnineRoute = PlaciloNajemnineRouteImport.update({
            id: '/placilo-najemnine',path: '/placilo-najemnine',getParentRoute: () => rootRouteImport
          })
const PiskotkiRoute = PiskotkiRouteImport.update({
            id: '/piskotki',path: '/piskotki',getParentRoute: () => rootRouteImport
          })
const ONasRoute = ONasRouteImport.update({
            id: '/o-nas',path: '/o-nas',getParentRoute: () => rootRouteImport
          })
const NavdihRoute = NavdihRouteImport.update({
            id: '/navdih',path: '/navdih',getParentRoute: () => rootRouteImport
          })
const NastaviGesloRoute = NastaviGesloRouteImport.update({
            id: '/nastavi-geslo',path: '/nastavi-geslo',getParentRoute: () => rootRouteImport
          })
const NarociloUspesnoRoute = NarociloUspesnoRouteImport.update({
            id: '/narocilo-uspesno',path: '/narocilo-uspesno',getParentRoute: () => rootRouteImport
          })
const NajemSpletneTrgovineRoute = NajemSpletneTrgovineRouteImport.update({
            id: '/najem-spletne-trgovine',path: '/najem-spletne-trgovine',getParentRoute: () => rootRouteImport
          })
const KosaricaRoute = KosaricaRouteImport.update({
            id: '/kosarica',path: '/kosarica',getParentRoute: () => rootRouteImport
          })
const IzbranoRoute = IzbranoRouteImport.update({
            id: '/izbrano',path: '/izbrano',getParentRoute: () => rootRouteImport
          })
const IdejeInNavdihRoute = IdejeInNavdihRouteImport.update({
            id: '/ideje-in-navdih',path: '/ideje-in-navdih',getParentRoute: () => rootRouteImport
          })
const BlagajnaRoute = BlagajnaRouteImport.update({
            id: '/blagajna',path: '/blagajna',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ProdajalciIndexRoute = ProdajalciIndexRouteImport.update({
            id: '/prodajalci/',path: '/prodajalci/',getParentRoute: () => rootRouteImport
          })
const KategorijeIndexRoute = KategorijeIndexRouteImport.update({
            id: '/kategorije/',path: '/kategorije/',getParentRoute: () => rootRouteImport
          })
const IzdelkiIndexRoute = IzdelkiIndexRouteImport.update({
            id: '/izdelki/',path: '/izdelki/',getParentRoute: () => rootRouteImport
          })
const ProdajalciSlugRoute = ProdajalciSlugRouteImport.update({
            id: '/prodajalci/$slug',path: '/prodajalci/$slug',getParentRoute: () => rootRouteImport
          })
const NovicePotrditevRoute = NovicePotrditevRouteImport.update({
            id: '/novice/potrditev',path: '/novice/potrditev',getParentRoute: () => rootRouteImport
          })
const KategorijeSlugRoute = KategorijeSlugRouteImport.update({
            id: '/kategorije/$slug',path: '/kategorije/$slug',getParentRoute: () => rootRouteImport
          })
const IzdelkiSlugRoute = IzdelkiSlugRouteImport.update({
            id: '/izdelki/$slug',path: '/izdelki/$slug',getParentRoute: () => rootRouteImport
          })
const ClanekSlugRoute = ClanekSlugRouteImport.update({
            id: '/clanek/$slug',path: '/clanek/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedZeljeRoute = AuthenticatedZeljeRouteImport.update({
            id: '/zelje',path: '/zelje',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedUstvarjalciRoute = AuthenticatedUstvarjalciRouteImport.update({
            id: '/ustvarjalci',path: '/ustvarjalci',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedTrgovinaRoute = AuthenticatedTrgovinaRouteImport.update({
            id: '/trgovina',path: '/trgovina',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedProdajaRoute = AuthenticatedProdajaRouteImport.update({
            id: '/prodaja',path: '/prodaja',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPostaniProdajalecRoute = AuthenticatedPostaniProdajalecRouteImport.update({
            id: '/postani-prodajalec',path: '/postani-prodajalec',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedNarocilaRoute = AuthenticatedNarocilaRouteImport.update({
            id: '/narocila',path: '/narocila',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedNajemninaRoute = AuthenticatedNajemninaRouteImport.update({
            id: '/najemnina',path: '/najemnina',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedMojiIzdelkiRoute = AuthenticatedMojiIzdelkiRouteImport.update({
            id: '/moji-izdelki',path: '/moji-izdelki',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedMigracijaSlikRoute = AuthenticatedMigracijaSlikRouteImport.update({
            id: '/migracija-slik',path: '/migracija-slik',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPredracunNovRoute = AuthenticatedPredracunNovRouteImport.update({
            id: '/predracun/nov',path: '/predracun/nov',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPredracunIdRoute = AuthenticatedPredracunIdRouteImport.update({
            id: '/predracun/$id',path: '/predracun/$id',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPovprasevanjeGroupIdRoute = AuthenticatedPovprasevanjeGroupIdRouteImport.update({
            id: '/povprasevanje/$groupId',path: '/povprasevanje/$groupId',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminOrodjaRoute = AuthenticatedAdminOrodjaRouteImport.update({
            id: '/orodja',path: '/orodja',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedPredracunUrediIdRoute = AuthenticatedPredracunUrediIdRouteImport.update({
            id: '/predracun/uredi/$id',path: '/predracun/uredi/$id',getParentRoute: () => AuthenticatedRoute
          })





const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminOrodjaRoute: AuthenticatedAdminOrodjaRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedMigracijaSlikRoute: AuthenticatedMigracijaSlikRoute,AuthenticatedMojiIzdelkiRoute: AuthenticatedMojiIzdelkiRoute,AuthenticatedNajemninaRoute: AuthenticatedNajemninaRoute,AuthenticatedNarocilaRoute: AuthenticatedNarocilaRoute,AuthenticatedPostaniProdajalecRoute: AuthenticatedPostaniProdajalecRoute,AuthenticatedProdajaRoute: AuthenticatedProdajaRoute,AuthenticatedTrgovinaRoute: AuthenticatedTrgovinaRoute,AuthenticatedUstvarjalciRoute: AuthenticatedUstvarjalciRoute,AuthenticatedZeljeRoute: AuthenticatedZeljeRoute,AuthenticatedPovprasevanjeGroupIdRoute: AuthenticatedPovprasevanjeGroupIdRoute,AuthenticatedPredracunIdRoute: AuthenticatedPredracunIdRoute,AuthenticatedPredracunNovRoute: AuthenticatedPredracunNovRoute,AuthenticatedPredracunUrediIdRoute: AuthenticatedPredracunUrediIdRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,BlagajnaRoute: BlagajnaRoute,IdejeInNavdihRoute: IdejeInNavdihRoute,IzbranoRoute: IzbranoRoute,KosaricaRoute: KosaricaRoute,NajemSpletneTrgovineRoute: NajemSpletneTrgovineRoute,NarociloUspesnoRoute: NarociloUspesnoRoute,NastaviGesloRoute: NastaviGesloRoute,NavdihRoute: NavdihRoute,ONasRoute: ONasRoute,PiskotkiRoute: PiskotkiRoute,PlaciloNajemnineRoute: PlaciloNajemnineRoute,PogojiRoute: PogojiRoute,PogostaVprasanjaRoute: PogostaVprasanjaRoute,PotrdiEmailRoute: PotrdiEmailRoute,PovzetekPogojevRoute: PovzetekPogojevRoute,PozabljenoGesloRoute: PozabljenoGesloRoute,PredstavitevProdajalcaRoute: PredstavitevProdajalcaRoute,PrijavaRoute: PrijavaRoute,RacunRoute: RacunRoute,RegistracijaRoute: RegistracijaRoute,ReklamacijeRoute: ReklamacijeRoute,ResetPasswordRoute: ResetPasswordRoute,UnikatneVsebineRoute: UnikatneVsebineRoute,UnsubscribeRoute: UnsubscribeRoute,UporabniskaNavodilaRoute: UporabniskaNavodilaRoute,UporabniskaNavodilaUstvarjalciRoute: UporabniskaNavodilaUstvarjalciRoute,ZasebnostRoute: ZasebnostRoute,ZaupanjeInVarnostRoute: ZaupanjeInVarnostRoute,ClanekSlugRoute: ClanekSlugRoute,IzdelkiSlugRoute: IzdelkiSlugRoute,KategorijeSlugRoute: KategorijeSlugRoute,NovicePotrditevRoute: NovicePotrditevRoute,ProdajalciSlugRoute: ProdajalciSlugRoute,IzdelkiIndexRoute: IzdelkiIndexRoute,KategorijeIndexRoute: KategorijeIndexRoute,ProdajalciIndexRoute: ProdajalciIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)